import {
  AuthButtonContainer,
  AuthFields,
  AuthForm,
  AuthFormSubtitle,
  AuthFormTitle,
  AuthLogo,
  AuthWrapper
} from "@/layouts/AuthLayout/style";

import { Link } from "react-router";
import styled from "styled-components";

export const Wrapper = styled(AuthWrapper)``;

export const LogoContainer = styled(AuthLogo)``;

export const Title = styled(AuthFormTitle)``;

export const SubTitle = styled(AuthFormSubtitle)``;

export const Form = styled(AuthForm)``;

export const Fields = styled(AuthFields)``;

export const ButtonContainer = styled(AuthButtonContainer)``;

export const ForgotLink = styled(Link)`
  display: block;
  font-weight: 400;
  font-size: 12px;
  text-decoration-line: underline;
  color: ${({ theme }) => theme.colors.deepDark};
  text-align: center;
  margin-top: 15px;
  @media (max-width: ${({ theme }) => theme.breakpoints.m}) {
    margin: 0;
    margin-bottom: 15px;
  }
`;

export const ErrorMsg = styled.p`
  color: ${({ theme }) => theme.colors.artyClickRed};
  text-align: center;
  margin-bottom: 10px;
`;
